import { useState, useReducer } from 'react';
import { useRetrieve } from './use-retrieve.js';
import { useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useQueryClient } from '@tanstack/react-query';
import useCreateItinerary from './use-createItinerary.js';

function isEqual(obj1, obj2) {
    var props1 = Object.getOwnPropertyNames(obj1);
    var props2 = Object.getOwnPropertyNames(obj2);
    if (props1.length != props2.length) {
        return false;
    }
    for (var i = 0; i < props1.length; i++) {
        let val1 = obj1[props1[i]];
        let val2 = obj2[props1[i]];
        let isObjects = isObject(val1) && isObject(val2);
        if ((isObjects && !isEqual(val1, val2)) || (!isObjects && val1 !== val2)) {
            return false;
        }
    }
    return true;
}
function isObject(object) {
    return object != null && typeof object === 'object';
}

export default function useOrders() {
    const { id } = useParams();
    const [params, setParams] = useState({
        serviceStart: '',
        connectionId: id,
        serviceEnd: '',
        queryText: '',
        PageNumber: 0,
        HideZeroOrders: true
    });
    const setPageNumber = (n) => {
        setParams({ ...params, PageNumber: n });
    };
    const resetSelected = () => {
        setSelectedRows([]);
        setImportFns([]);
        setIsAllSelected(false);
    };
    const queryClient = useQueryClient();
    const [, forceUpdate] = useReducer((x) => x + 1, 0);
    const [selectedRows, setSelectedRows] = useState([]);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const { data, ...flags } = useRetrieve(params);

    const [importFns, setImportFns] = useState([]);
    const multiImportFn = useCreateItinerary({
        mutationKey: ['createOrder'],
        onSuccess: async (data, variables, context) => {
            data.ok ? toast.success('Import successfull') : toast.error('Import error');
            //resetSelected();
            const oldData = await queryClient.getQueryData(
                ['bookings', params.queryText, params.serviceStart, params.serviceEnd],
                { exact: false }
            );
            const actualData = structuredClone(oldData);
            for (const number of variables.numOrders) {
                const { title, id } = data.results.find((v) => v.number === number);
                actualData?.pages?.flatMap((page, i) => {
                    const index = page?.results?.map((v) => v.number).indexOf(number);
                    if (index === -1) return;
                    actualData.pages[i].results[index].imports.push({ itineraryName: title, id });
                });
            }
            queryClient.setQueryData(
                ['bookings', params.queryText, params.serviceStart, params.serviceEnd],
                actualData
            );
            forceUpdate();
        },
        onError: () => toast.error('Server Error')
    });
    const fetchNextPage = () => {
        flags.fetchNextPage({ pageParam: { ...params, PageNumber: params.PageNumber + 1 } });
    };
    const onSubmitSearch = (data) => {
        if (data.startDate > data.endDate) return toast.error(_t.orders.dateError());
        const newParams = {
            connectionId: id,
            serviceStart: data.startDate,
            serviceEnd: data.endDate,
            queryText: data.query,
            PageNumber: 0,
            HideZeroOrders: true
        };
        setParams(newParams);
        resetSelected();
        if (isEqual(params, newParams)) flags.refetch();
    };

    const importMutation = (language) => multiImportFn.mutate({ connectionId: id, numOrders: importFns, language });
    return {
        data,
        flags,
        selectedRows,
        setSelectedRows,
        isAllSelected,
        setIsAllSelected,
        connectionId: id,
        importFns,
        setImportFns,
        onSubmitSearch,
        importMutation,
        setPageNumber,
        importLoading: multiImportFn.isLoading,
        fetchNextPage,
        resetSelected,
        params
    };
}
